var _styled, _styled2;

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { MEDIA_QUERIES } from '@govuk-react/constants';
var Label = styled('label')((_styled = {}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  display: 'none'
}, _styled));
var Input = styled('input')((_styled2 = {
  position: 'absolute',
  top: '-999em',
  // This is reliant on HTML structure of parent component.
  // If we wanted to create a React Native version of this component,
  // we wouldn't be able to rely on HTML syntax for styles.
  // For React Native we would want to lift up state to
  // parent component and/or use context API.
  // However, using this technique, the navigation can be used when
  // server side rendered and with JavaScript disabled.
  // As we are in control of the HTML structure of the parent component,
  // and we do not plan to make a React Native version of this component at
  // the moment, this is ok.
  ':checked + ul': {
    display: 'flex'
  }
}, _styled2[MEDIA_QUERIES.LARGESCREEN] = {
  display: 'none'
}, _styled2));

var MenuButton = function MenuButton(_ref) {
  var title = _ref.title;
  return React.createElement(React.Fragment, null, React.createElement(Label, {
    htmlFor: "govuk-react-menu-button"
  }, title, " ", React.createElement("span", null, "\u203A")), React.createElement(Input, {
    id: "govuk-react-menu-button",
    type: "checkbox"
  }));
};

MenuButton.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.string
} : {};
MenuButton.defaultProps = {
  title: 'Menu'
};
export default MenuButton;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/top-nav/es/atoms/menu-button/index.js
// module id = 118
// module chunks = 0